module.exports = __webpack_public_path__ + "img/t1.c3bebe87.png";